import { Notice } from "../components/index.ts";
import { useLabels } from "@teamna/web-client/hooks/use-labels.ts";

/**
 * What an owner sees in place of a card payment part while Teamna has card payments off for all
 * businesses (Control Center switch, `MyBusiness.cardPaymentsComingSoon`). Cash and bank transfer
 * payments still work, so the box says so.
 */
export function CardPaymentsComingSoon({ title = "Card payments are coming soon" }: { title?: string }) {
  const { label } = useLabels();
  return (
    <Notice tone="info" title={title}>
      {`Soon ${label("member", { plural: true })} can pay you by card in the Teamna app and with payment links. Until then, record cash and bank transfer payments in Teamna.`}
    </Notice>
  );
}
